import React from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { COLORS } from '../styles/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MonthPicker = React.forwardRef((props, parentRef) => {
  return (
    <div style={{
      border: '1px solid '+COLORS.grey,
      display: 'initial',
      padding: 5,
      borderRadius: 3
    }}>
      <div
        style={{
          display: 'initial'
        }}>
        <DatePicker
          ref={(ref) => {
            parentRef = ref;
          }}
          selected={props.selected}
          onChange={props.onChange}
          dateFormat={props.isDayPicker ? "MM/yyyy/dd" : "MM/yyyy"}
          showMonthYearPicker = {!props.isDayPicker}
        />
      </div>
      <div
        onClick={() => {
          parentRef.input.click();
        }}
        style={{
          cursor: 'pointer',
          display: 'initial',
          height: '100%',
          borderLeft: '1px solid '+COLORS.grey,
          padding: '5px',
          paddingLeft: '10px'
        }}>
        <FontAwesomeIcon
          icon="calendar"
          style={{
            color: COLORS.grey,
            fontSize: 18
          }}
        />
      </div>

    </div>
  )

});

export default MonthPicker



// WEBPACK FOOTER //
// ./src/components/MonthPicker.js